module.exports = __webpack_public_path__ + "i18n/es.dd552e51cae42478ec63c995973a0cb1.json";